<!--
   Created by qing on 2020/2/27 3:48 下午
   Des:
-->
<template>
  <div>
    <van-cell class="ry-form__single-choose" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead">
       <span
         v-if="current.showColor"
         :class="{'readonly-span' : currentRow[current.dataId] && currentRow[current.dataId].length}"
         :style="{backgroundColor : currentRow[current.dataId] && currentRow[current.dataId].length ? contentColor : ''}">
          {{contentText}}
        </span>
          <span v-else>
          {{contentText}}
        </span>
        </div>
        <van-radio-group
          v-if="!isRead"
          :disabled="isReadOnly"
          @change="selectChange"
          v-model="selectOpt">
          <van-radio
            v-for="(opt, idx) in currentRowOpts"
            icon-size="16"
            :key="opt.id"
            :name="opt.id">
          <span
            :style="{backgroundColor: current.showColor ? opt.color || '#63B2EE' : '#fff', color: current.showColor ? '#fff' : '#000'}">
            {{ opt.optionName }}
          </span>
          </van-radio>
        </van-radio-group>

        <van-field
          v-if="!isRead && selectOption === '其他'"
          style="border: 1px solid #e6e6e6; padding: 5px;"
          v-model="currentRow[current.dataId]"
          @change="selectChange"
        ></van-field>
      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__single-choose-compact">

      <van-field
        :label="current.title"
        :label-class="{'readonly-field-label': !isRead && isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>

          <div class="ry-form__select-compact-container">

            <div v-if="isRead">
          <span
            v-if="current.showColor"
            class="field-empty-tips"
            :class="{'readonly-span' : currentRow[current.dataId] && currentRow[current.dataId].length}"
            :style="{backgroundColor : currentRow[current.dataId] && currentRow[current.dataId].length ? contentColor : ''}">
            {{contentText}}
          </span>
              <span v-else class="field-empty-tips">
            {{contentText}}
          </span>
            </div>

            <div v-else class="ry-form__dropdown-input compact-container">
              <van-radio-group
                v-if="!isRead"
                :disabled="isReadOnly"
                direction="horizontal"
                @change="selectChange"
                v-model="selectOpt">
                <van-radio
                  v-for="(opt, idx) in currentRowOpts"
                  icon-size="16"
                  :key="opt.id"
                  :name="opt.id">
            <span
              :style="{backgroundColor: current.showColor ? opt.color || '#63B2EE' : '#fff', color: current.showColor ? '#fff' : '#000'}">
              {{ opt.optionName }}
            </span>
                </van-radio>
              </van-radio-group>

              <van-field
                v-if="!isRead && selectOption === '其他'"
                style="border: 1px solid #e6e6e6; padding: 5px;"
                v-model="currentRow[current.dataId]"
                @change="selectChange"
              ></van-field>
            </div>
          </div>
        </template>
      </van-field>
    </div>

    <RySelectPopup
      v-if="current.pluginConfig && current.pluginConfig.entryId"
      ref="rySelectPopup"
      :title="current.title"
      @selectComplete="selectComplete">
    </RySelectPopup>
  </div>

</template>

<script>
  import {current} from './mixin'

  export default {
    mixins: [current],
    data () {
      return {
        selectOption: ''
      }
    },
    computed: {
      // 获取options, 因为子表单选项类控件可能每一行不一样
      currentRowOpts() {
        const optionsMap = this.currentRow['optionsMap'] || {}
        return optionsMap[this.current.dataId] || this.current.options
      },
      contentText() {
        if (this.currentRow[this.current.dataId] && this.currentRow[this.current.dataId].length) {
          const opt = this.currentRowOpts
            .filter(opt => opt.id === this.currentRow[this.current.dataId])[0]
          return opt ? opt.optionName : this.currentRow[this.current.dataId]
        } else {
          return '暂无内容'
        }
      },

      contentColor() {
        if (this.currentRow[this.current.dataId] && this.currentRow[this.current.dataId].length) {
          const opt = this.currentRowOpts
            .filter(opt => opt.id === this.currentRow[this.current.dataId])[0]
          return opt ? opt.color : '#63B2EE'
        } else {
          return ''
        }
      },
      selectOpt: {
        set(val) {
          this.selectOption = val
          this.currentRow[this.current.dataId] = val
          // 当前控件设置过选项关联
          if (this.current.relateField === 1) {
            this.currentRowOpts.forEach(opt => {
              if (opt.optionName === val) {
                // 找出当前选择的选项关联的目标字段，给目标字段的followShowList中加入自己的Id
                opt.fieldsMap.forEach(fieldId => {
                  let field = this.current.root.fields[fieldId]
                  field.followShowList.push(`${this.current.dataId}_${opt.id}`)
                })
              } else {
                // 找出没有选择的选项关联的目标字段，把目标字段的followShowList中自己的Id移除掉
                opt.fieldsMap.forEach(fieldId => {
                  let field = this.current.root.fields[fieldId]
                  for (let i = field.followShowList.length - 1; i >= 0; i--) {
                    let id = field.followShowList[i]
                    if (id === `${this.current.dataId}_${opt.id}`) {
                      field.followShowList.splice(i, 1)
                    }
                  }
                })
              }
            })
          }
        },
        get() {
          if (this.currentRow[this.current.dataId]) {
            const option = this.currentRowOpts.filter(opt => opt.id === this.currentRow[this.current.dataId])[0]
            if (!option || this.currentRow[this.current.dataId] === '其他') {
              this.selectOption = '其他'
            }
            return option ? option.optionName : '其他'
          } else {
            if (this.selectOption === '其他') {
              return '其他'
            }
            return ''
          }
        }
      }
    },
    methods: {

      selectChange() {
        this.controlChange()
        this.submitData()
      }
    }
  }
</script>